import { createSlice } from "@reduxjs/toolkit";

const INITIAL_SAVED_SUCCESSFULLY = { // used for syncronising the save between different tabs to show a single success message
    advanceSettings: false,
    coursePlan: false,
    basicInfo: false
}

const INITIAL_STATE = {
    isCourseCreated: false,
    bulkReport: [],
    bulkReportCount: 0,
    isCourseUpdated: false,
    errors: {
        duplicateSKUMessage: [''],
        startEndDateError: ['']
    },
    activeGoals: [],
    activeCourses: [],
    userSuggestions: [],
    generalSettings: {
        availableForB2C: false,
        availableForTestUsers: false,
        isPaid: '',
        price: 0,
        discount: 0,
        localeWisePrice: [],
        otherInfo: {
            mainTests:'',
            conceptTests:''
        }
    },
    faq: {
        FAQ:[]
    },
    seo: {
        metatags: {
            title: '',
            description: '',
            keywords: ''
        }
    },
    packageId: '',
    testSeries:{
        packageId:'',
        testCount:'',
        minStartDate:'',
        basicDetail: {},
    },
    existingScheduledTests : [],
    mapTestSuggestions: [],
    coursesByScheduleId: [],
    scheduledTests:[],
    treeDataView : {},
    basicInfo: {},
    courseBasicDetails:{},
    savedSuccessfully: INITIAL_SAVED_SUCCESSFULLY,
    isContentLoading:false,
    packagesContent:[],
    stopPollingStatusApi:false,
    courseChangeData: {},
    courseChangePayload: {},
}

const courseManagementSlice = createSlice({
    name : 'courseManagement',
    initialState : INITIAL_STATE,
    reducers : {
        resetToInitialState: (state, action) => {
            state = JSON.parse(JSON.stringify(INITIAL_STATE))
        },
        setActiveGoals: (state, action) => {
            state.activeGoals = action.payload
        },
        setDuplicateSKUMessage: (state, action) => {
             state.errors.duplicateSKUMessage = action.payload
        },
        setStartEndDateError: (state, action) => {
            state.errors.startEndDateError = action.payload
        },
        setActiveCourses: (state, action) => {
            state.activeCourses = action.payload
        },
        setIsCourseCreated: (state, action) => {
            state.isCourseCreated = action.payload
        },
        setBulkReport: (state, action) => {
            state.bulkReport = action.payload.results;
            if(action.payload.totalCount) {
                state.bulkReportCount = action.payload.totalCount;
            }
        },
        setIsCourseUpdated: (state, action) => {
            state.isCourseUpdated = action.payload
        },
        setUserSuggestions: (state, action) => {
            state.userSuggestions = action.payload
        },
        setPackageId: (state, action) => {
             state.packageId = action.payload
        },
        setGeneralSettings: (state, action) => {
            state.generalSettings = {...action.payload}
        },
        setFAQ: (state, action) => {
            state.faq = {...action.payload}
        },
        setSEO: (state, action) => {
            state.seo = {...action.payload}
        },
        setTestSeriesPackageId:(state,action)=>{
            state.testSeries.packageId=action.payload;
        },
        setExistingScheduledTests:(state, action) => {
            state.existingScheduledTests=action.payload;
         },
        setMapTestSuggestions:(state, action) => {
            state.mapTestSuggestions=action.payload
        },
        setTreeViewData:(state, action) => {
            const {payload} = action;
            state.treeDataView = {...state.treeDataView,...payload}
        },
        setCoursesByScheduleId:(state, action) => {
            state.coursesByScheduleId=action.payload
        },
        setScheduledTests:(state, action) => {
            state.scheduledTests=action.payload;
        },
        setBasicInfo: (state, action) => {
            state.basicInfo = action.payload
        },
        setCourseBasicDetails: (state, action) => {
            state.courseBasicDetails = action.payload
        },
        setTestCount:(state,action)=>{
            state.testSeries.testCount=action.payload
        },
        setMinStartDate:(state,action)=>{
            state.testSeries.minStartDate=action.payload
        },
        setTestSeriesBasicInfo:(state,action)=>{
           state.testSeries.basicDetail=action.payload
        },
        setSavedSuccessfully: (state, action) => {
            const { key, value } = action.payload
            state.savedSuccessfully = {...state.savedSuccessfully, [key]: value};
        },
        resetSavedSuccessfully: (state, action) => {
            state.savedSuccessfully = INITIAL_SAVED_SUCCESSFULLY;
        },
        setPackagesContent:(state,action)=>{
            state.isContentLoading=false;
            state.packagesContent=action.payload;
        },
        fetchContentFromPackages:(state,action)=>{
          state.isContentLoading=true;
        },
        setPollingStatus:(state,action)=>{
            state.stopPollingStatusApi=action.payload;
        },
        setCourseRequest: (state = {}, actions = {}) => {
            state.courseRequest = actions.payload;
        },
        setRejectionRemark: (state = {}, action) => {
            state.rejectionRemarkVisible = !state.rejectionRemarkVisible;
            if (action.payload) {
                state.requestState = action.payload;
            }
        },
        setCourseChangePopup: (state = {}, actions = {}) => {
            state.courseChangeData = actions.payload;
        },
        setCourseChangePayload: (state = {}, actions = {}) => {
            state.courseChangePayload = actions.payload;
        },
        setIsDifferentUser: (state = {}, actions = {}) => {
            state.isDifferentUser = actions.payload;
        },
    }
})



const { actions, reducer }  = courseManagementSlice;

export default reducer;
export const courseManagementActions = actions;